<template>
    <div>
        <div class="search-box">
            <p>考核年份：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY'
                allowClear=false
                placeholder="请选择考核年份"
                v-model="searchFrom.assessmentYear" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne"/>
            <p>教师姓名：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" allowClear placeholder="请输入教师姓名"/>
            <p>状态：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.approvalStatus">
                <a-select-option value="draft">草稿</a-select-option>
                <a-select-option value="commit">已提交</a-select-option>
                <a-select-option value="approved">已审核</a-select-option>
                <a-select-option value="reject">已驳回</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
        </div>
        <div class="operation-box">
            <a-button 
                type="primary"
                icon="plus" 
                class="btn" 
                @click="$router.push('/admin/faculty/staffAssessment/info?type=add')"
                v-if="!isAdmin">
                 新增考核
            </a-button>
        </div>
        <a-table 
            rowKey='id'
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            bordered>
            <template slot="status" slot-scope="text">
                <a-tag :color="getStatusColor(text)">{{getStatusText(text)}}</a-tag>
            </template>
            <template slot="rating" slot-scope="text">
                <span v-if="text">{{getRatingText(text)}}</span>
                <span v-else>-</span>
            </template>
            <template slot="action" slot-scope="text, record">
                <a class="action-btn" @click="viewDetail(record)">查看</a>
                <a-divider type="vertical" v-if="record.approvalStatus == 'draft' && !isAdmin"/>
                <a class="action-btn" v-if="record.approvalStatus == 'draft' && !isAdmin" @click="editDetail(record)">编辑</a>
                <a-divider type="vertical" v-if="record.approvalStatus == 'draft' && !isAdmin"/>
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(record.id)"
                    v-if="record.approvalStatus == 'draft' && !isAdmin">
                    <a class="action-btn">删除</a>
                </a-popconfirm>
                <a-divider type="vertical" v-if="record.approvalStatus == 'commit' && isAdmin"/>
                <a class="action-btn" v-if="record.approvalStatus == 'commit' && isAdmin" @click="approveDetail(record)">审核</a>
            </template>
        </a-table>
    </div>
</template>
<script>
    import { list, del } from '@/baseAPI/staffAssessment'

    export default {
        name: 'staffAssessment',
        components: {},
        data () {
            return {
                isAdmin: false,
                columns:[
                    {
                        title: '序号',
                        dataIndex: 'id',
                        align:'center',
                        width:80,
                        customRender: (text, row, index) => {
                            return { children: index+1};
                        },
                    },
                    {
                        title: '考核年份',
                        dataIndex: 'assessmentYear',
                        align:'center'
                    },
                    {
                        title: '教师编号',
                        dataIndex: 'teacherId',
                        align:'center',
                    },
                    {
                        title: '教师姓名',
                        dataIndex: 'teacherName',
                        align:'center',
                    },
                    {
                        title: '职位/岗位',
                        dataIndex: 'position',
                        align:'center'
                    },
                    {
                        title: '综合评价',
                        dataIndex: 'comprehensiveRating',
                        align:'center',
                        scopedSlots: { customRender: 'rating' }
                    },
                    {
                        title: '状态',
                        dataIndex: 'approvalStatus',
                        align:'center',
                        scopedSlots: { customRender: 'status' }
                    },
                    {
                        title: '提交时间',
                        dataIndex: 'submittedAt',
                        align:'center',
                    },
                    {
                        title: '操作',
                        align:'center',
                        scopedSlots: { customRender: 'action' },
                    }
                ],
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    assessmentYear:'',
                    approvalStatus:''
                },
                year: '',
                yearShowOne: false,
                yearOptions: [],
                usedYears: []
            }
        },
        mounted () {
            this.checkAdminPermission()
            this.searchFrom.assessmentYear = new Date().getFullYear() + ''
            this.fetch()
        },
        methods:{
            getTimeStr(time, format){
                let date = new Date(time)
                let year = date.getFullYear()
                return year
            },
            openChangeOne(status) {
                if (status) {
                    this.yearShowOne = true
                }
            },
            panelChangeOne(value) {
                this.year = this.getTimeStr(value._d, 'yyyy') + ''
                this.searchFrom.assessmentYear = this.year
                this.yearShowOne = false
            },
            handleYearChange(date) {
                if (!date) {
                    this.year = ''
                    this.searchFrom.assessmentYear = ''
                }
            },
            checkAdminPermission(){
                const permissions = this.$store.state.user.permissions || []
                this.isAdmin = permissions.indexOf('STAFF_ASSESS_ADMIN') > -1
            },
            getStatusColor(status){
                switch(status){
                    case 'draft': return 'default'
                    case 'commit': return 'blue'
                    case 'approved': return 'green'
                    case 'reject': return 'red'
                    default: return 'default'
                }
            },
            getStatusText(status){
                switch(status){
                    case 'draft': return '草稿'
                    case 'commit': return '已提交'
                    case 'approved': return '已审核'
                    case 'reject': return '已驳回'
                    default: return status
                }
            },
            getRatingText(rating){
                switch(rating){
                    case 'excellent': return '优秀'
                    case 'good': return '合格'
                    case 'qualified': return '基本合格'
                    case 'unqualified': return '不合格'
                    default: return rating
                }
            },
            viewDetail(record){
                this.$router.push('/admin/faculty/staffAssessment/info?id='+record.id+'&type=view')
            },
            editDetail(record){
                this.$router.push('/admin/faculty/staffAssessment/info?id='+record.id+'&type=edit')
            },
            approveDetail(record){
                this.$router.push('/admin/faculty/staffAssessment/info?id='+record.id+'&type=approve')
            },
            handleTableChange(pagination){
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除考核记录成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }
    .operation-box .btn{
        margin-right: 1rem;
    }
</style>
